import { GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf.mjs'
import {
  EventBus,
  PDFFindController,
  PDFLinkService,
  PDFViewer,
} from 'pdfjs-dist/legacy/web/pdf_viewer.mjs'

import { getBaseDomain } from '../../../../utils/route'
import { PDF_VIEWER_ASSETS_URL, ScrollMode } from '../../PdfViewer.constants'

function configurePdfViewerWorker() {
  if (!GlobalWorkerOptions.workerSrc) {
    // webpack emits the worker as an asset and resolves the URL at build time
    GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/legacy/build/pdf.worker.min.mjs',
      import.meta.url
    ).toString()
  }
}

// the auth cookie lives on our domain; third-party hosts (Google export links) reject credentialed CORS
function checkIsSameBaseDomainUrl(url) {
  const { hostname } = new URL(url, window.location.origin)

  return getBaseDomain(hostname) === getBaseDomain(window.location.hostname)
}

export function createPdfViewerInstance({ container, singlePage, viewer }) {
  configurePdfViewerWorker()

  const eventBus = new EventBus()
  const linkService = new PDFLinkService({ eventBus })
  const findController = new PDFFindController({ eventBus, linkService })

  const pdfViewer = new PDFViewer({
    container,
    eventBus,
    findController,
    linkService,
    removePageBorders: true,
    viewer,
  })

  linkService.setViewer(pdfViewer)

  if (singlePage) {
    pdfViewer.scrollMode = ScrollMode.PAGE
  }

  return { eventBus, findController, pdfViewer }
}

export function getPdfViewerDocumentUrl(file) {
  return file?.localUrl || file?.origin
}

export function getPdfViewerDocumentInitParameters(url) {
  return {
    cMapUrl: `${PDF_VIEWER_ASSETS_URL}cmaps/`,
    iccUrl: `${PDF_VIEWER_ASSETS_URL}iccs/`,
    standardFontDataUrl: `${PDF_VIEWER_ASSETS_URL}standard_fonts/`,
    url,
    wasmUrl: `${PDF_VIEWER_ASSETS_URL}wasm/`,
    withCredentials: checkIsSameBaseDomainUrl(url),
  }
}
